import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAccessExpired } from '../context/accountUtils';

const ProtectedRoute = ({ children }) => {
  const { user, logout } = useAuth();
  const token = localStorage.getItem('token');
  const location = useLocation();
  const expired = isAccessExpired();

  const onUpgradePage = location.pathname === '/profile' && new URLSearchParams(location.search).get('upgrade') === '1';

 useEffect(() => {
    if ((!user || !token) && !onUpgradePage) {
      logout();
    }
  }, [user, token, onUpgradePage, logout]);

  // Not logged in at all -> login
  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }

  // Logged in BUT plan is expired -> send to upgrade page (once)
  if (expired && !onUpgradePage) {
    return <Navigate to="/profile?upgrade=1" replace />;
  }

  // Normal case: allowed into protected route
  return children;
};

export default ProtectedRoute;
